import { useState } from "react";

/**
 * Login-time 6-digit authenticator step (no QR).
 */
export function TotpChallengeStep({ onSubmit, onBack, loading, error }) {
  const [code, setCode] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(code.replace(/\s+/g, ""));
  };

  return (
    <form className="login-page__form" onSubmit={handleSubmit} noValidate>
      {error ? (
        <div className="login-page__error" role="alert">
          <i className="ri-error-warning-line" aria-hidden="true" />
          <span>{error}</span>
        </div>
      ) : null}
      <div className="login-page__field">
        <label className="login-page__label" htmlFor="login-totp-code">
          Authenticator code
        </label>
        <div className="login-page__control-wrap">
          <i className="ri-shield-keyhole-line login-page__control-icon" aria-hidden="true" />
          <input
            id="login-totp-code"
            className="login-page__control"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]*"
            maxLength={8}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/[^\d]/g, "").slice(0, 6))}
            placeholder="6-digit code"
            required
            disabled={loading}
            autoFocus
          />
        </div>
      </div>
      <button type="submit" className="login-page__submit" disabled={loading || code.length < 6}>
        {loading ? (
          <>
            <i className="ri-loader-4-line login-page__spin" aria-hidden="true" />
            Verifying…
          </>
        ) : (
          "Continue"
        )}
      </button>
      {onBack ? (
        <button type="button" className="login-page__google" onClick={onBack} disabled={loading}>
          Back to sign in
        </button>
      ) : null}
    </form>
  );
}
